import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import React, { useState } from "react";
import CellTypesEditor from "./CellTypesEditor";
import CellValuesEditor, { IUniversalDatasetTableConfig } from "./CellValuesEditor";

interface UniversalDatasetEditorDialogProps {
  config: IUniversalDatasetTableConfig;
  onConfigChange: (config: IUniversalDatasetTableConfig) => void;
  setDialogVisible: (visible: boolean) => void;
  isDialogVisible: boolean;
}

const UniversalDatasetEditorDialog = ({
  setDialogVisible,
  isDialogVisible,
  config,
  onConfigChange,
}: UniversalDatasetEditorDialogProps) => {
  const defaultConfig = {
    rows: config.rows ?? [],
    columnsOptions: config.columnsOptions ?? [],
    showColumnHeaders: config.showColumnHeaders ?? true,
    compactMode: config.compactMode ?? false,
    updateFrequency: config.updateFrequency ?? 0,
  };

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [currentConfig, setCurrentConfig] = useState<IUniversalDatasetTableConfig>(defaultConfig);

  const saveChanges = () => {
    onConfigChange(currentConfig);
    setDialogVisible(false);
  };
  const dialogFooterTemplate = () => {
    return (
      <div className="flex justify-content-end gap-2">
        <Button
          label={T("action.cancel")}
          icon="pi pi-times"
          onClick={() => setDialogVisible(false)}
          className="component-editor-button icon-red"
        />
        <Button
          label={T("action.save")}
          icon="pi pi-check"
          onClick={saveChanges}
          className="component-editor-button icon-green"
        />
      </div>
    );
  };

  return (
    <Dialog
      header={T("header.edit-dataset-table")}
      visible={isDialogVisible}
      modal={false}
      style={{ width: "90vw", minHeight: "500px" }}
      onHide={() => setDialogVisible(false)}
      maximizable
      footer={dialogFooterTemplate}
    >
      <TabView activeIndex={activeTabIndex} onTabChange={e => setActiveTabIndex(e.index)}>
        <TabPanel header={T("header.cell-types")}>
          <CellTypesEditor currentConfig={currentConfig} setCurrentConfig={setCurrentConfig} />
        </TabPanel>
        <TabPanel header={T("header.cell-values")}>
          <CellValuesEditor currentConfig={currentConfig} setCurrentConfig={setCurrentConfig} />
        </TabPanel>
      </TabView>
    </Dialog>
  );
};

export default UniversalDatasetEditorDialog;
